"use client";

import { usePathname } from "next/navigation";
import { localizedPath, useLocale } from "@/i18n/locale";

export function LanguageSwitcher({ mobile = false }: { mobile?: boolean }) {
  const locale = useLocale();
  const pathname = usePathname();

  return (
    <div
      data-no-translate
      className={`inline-flex items-center rounded-full border border-line bg-bg-panel/70 p-1 ${
        mobile ? "w-full justify-center" : ""
      }`}
      role="group"
      aria-label={locale === "en" ? "Choose language" : "Escolher idioma"}
    >
      <a
        data-language-link="pt"
        href={localizedPath(pathname, "pt")}
        hrefLang="pt-BR"
        lang="pt-BR"
        aria-current={locale === "pt" ? "page" : undefined}
        className={`rounded-full px-2.5 py-1 font-mono text-xs font-semibold transition-colors ${
          locale === "pt"
            ? "bg-accent-lime text-ink-black"
            : "text-text-secondary hover:text-text-primary"
        }`}
      >
        PT
      </a>
      <a
        data-language-link="en"
        href={localizedPath(pathname, "en")}
        hrefLang="en"
        lang="en"
        aria-current={locale === "en" ? "page" : undefined}
        className={`rounded-full px-2.5 py-1 font-mono text-xs font-semibold transition-colors ${
          locale === "en"
            ? "bg-accent-lime text-ink-black"
            : "text-text-secondary hover:text-text-primary"
        }`}
      >
        EN
      </a>
    </div>
  );
}
